import type { TourDefinition } from '@renderer/hooks/useTour';

/**
 * Sprint 10 — Tour de la vista de Mesas.
 * Sprint 48 — Paso 3 actualizado: Sprint 29.1 reemplazó el menú ⋮ por botones
 * directamente visibles en la tarjeta. Se agregó paso sobre "Volver a juntar".
 */
export const tourMesas: TourDefinition = {
  id: 'mesas',
  title: 'Cómo usar la vista de Mesas',
  steps: [
    {
      element: '[data-tour="mes-contadores"]',
      popover: {
        title: '1. Contadores del salón',
        description:
          'De un vistazo: mesas libres, ocupadas, fuera de servicio, con cocina lista y con cuenta solicitada. El número en rojo significa que hay algo que resolver.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="mes-grid"]',
      popover: {
        title: '2. Grid visual de mesas',
        description:
          'Cada tarjeta es una mesa. Verde = libre, naranja = ocupada con pedido, gris = fuera de servicio. Toca una mesa libre para abrir un nuevo pedido; toca una ocupada para ver su cuenta.',
        side: 'top',
      },
    },
    {
      element: '[data-tour="mes-acciones"]',
      popover: {
        title: '3. Acciones del pedido (botones directos)',
        description:
          'Cuando una mesa está ocupada, verás dos filas de botones: la fila verde/azul para "Agregar productos" y "Cobrar"; la fila gris para acciones extra: Pidió cuenta · Ver ticket · Dividir cuenta · Mover mesa · Juntar mesas. Si la cuenta está dividida, aparece "Volver a juntar" para reagruparla.',
        side: 'left',
      },
    },
  ],
};
